import { CarouselTeam } from '@/lib/ui-kit/components/CarouselTeam.components'
import { CarouselItem } from '@/lib/ui-kit/components/ui/Carousel.component'

import { TabType } from '../sections/SectionBoardContent.component'

import CardBoardMember from './CardBoardMember.component'

interface CardsBoardMembersProps {
  boardMembers: any[]
  activeTab: TabType
  tabType: TabType
}

export const CardsBoardMembers = ({
  boardMembers,
  activeTab,
  tabType,
}: CardsBoardMembersProps) => {
  return (
    <div
      className={`${
        activeTab === tabType ? 'flex' : 'hidden'
      } mx-[-10px] my-[-20px] w-full flex-wrap items-start justify-between px-0 pb-4 pt-0 xl:mx-0 xl:my-0 xl:flex-nowrap xl:justify-start xl:gap-[16px]`}
    >
      {Boolean(boardMembers.length) && (
        <div className="hidden w-full xl:block">
          <CarouselTeam>
            {boardMembers.map(
              ({ fullName, role, avatar, links, bio }, index) => {
                return (
                  <CarouselItem
                    key={index}
                    className="md:basis-1/2 lg:basis-1/4"
                  >
                    <CardBoardMember
                      name={fullName}
                      role={role}
                      imageUrl={avatar?.url || ''}
                      alternativeText={
                        avatar?.alternativeText || 'Board member image'
                      }
                      links={links}
                      bio={bio}
                    />
                  </CarouselItem>
                )
              },
            )}
          </CarouselTeam>
        </div>
      )}
      {Boolean(boardMembers.length) && (
        <div className="basis-1/1 flex flex-wrap xl:hidden">
          {boardMembers.map(({ fullName, role, avatar, links, bio }, index) => {
            return (
              <CardBoardMember
                key={index}
                name={fullName}
                role={role}
                imageUrl={avatar?.url || ''}
                alternativeText={
                  avatar?.alternativeText || 'Board member image'
                }
                links={links}
                bio={bio}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
